import React from 'react';
import { buildResearchUnlockMailto, RESEARCH_LOCKED_TITLE } from '../config/researchFeatures';
import './ResearchLockedNotice.css';

/**
 * Ersetzt die Feature-Tags eines gesperrten Research-Tools. Bewusst nur eine
 * gedämpfte Textzeile mit Inline-Link statt Kasten und Button: Die Karte ist
 * schon als gesperrt erkennbar, der Hinweis soll sie nicht überlagern.
 *
 * Die Karten sind klickbare <button>/<label>-Elemente, deshalb stoppt der
 * Mail-Link die Propagation: Anfragen darf man auch bei gesperrtem Tool.
 */
const ResearchLockedNotice = ({ featureName, accountEmail, worldId }) => {
  const mailto = buildResearchUnlockMailto({ featureName, accountEmail, worldId });

  return (
    <span className="research-locked">
      <span className="research-locked__text">{RESEARCH_LOCKED_TITLE}</span>
      <a
        className="research-locked__cta"
        href={mailto}
        onClick={(e) => e.stopPropagation()}
      >
        Request access
        <i className="fa fa-arrow-right" />
      </a>
    </span>
  );
};

export default ResearchLockedNotice;
